module.exports = __webpack_public_path__ + "img/example-videowall-weekly-menu.7bdcf197.png";